import { connect } from 'react-redux';
import { compose } from 'redux';
import withReducer from '@Hooks/withReducer';
import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';
import queryletReducer from '../QueryletReducer';
import {
  addToBuilderAction,
  initNodeList,
  onToggleQueryletAction,
  getFormsAction,
  getHistoryItemsAction,
  cleanupOnUnmountAction,
} from '../QueryletActions';
import {
  nodesList as nodesListSelector,
  favList as favlistSelector,
  hiddenList as hiddenListSelector,
  properties as propertiesSelector,
  forms as formsSelector,
  historyItems as historyItemsSelector,
  indexedQuerylets as indexedQueryletsSelector,
  indexedForms as indexedFormsSelector,
  importedQuery as importedQuerySelector,
} from '../QuerySelector';
import QueryContainer from './QueryContainerBase';

const mapStateToProps = (state) => ({
  nodesList: nodesListSelector(state),
  favList: favlistSelector(state),
  hiddenList: hiddenListSelector(state),
  properties: propertiesSelector(state),
  forms: formsSelector(state),
  historyItems: historyItemsSelector(state),
  indexedQuerylets: indexedQueryletsSelector(state),
  indexedForms: indexedFormsSelector(state),
  importedQuery: importedQuerySelector(state),
});

const mapDispatchToProps = {
  initNodeList,
  addToBuilderAction,
  onToggleQueryletAction,
  getFormsAction,
  getHistoryItemsAction,
  cleanupOnUnmountAction,
};

export default compose(
  withCombinedRouteParams,
  withReducer('queryletReducer', queryletReducer, []),
  connect(mapStateToProps, mapDispatchToProps)
)(QueryContainer);
